import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import {
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES,
  isLocale,
  type SupportedLocale,
} from "@translations/config";

import aboutEn from "@translations/en/about.json";
import commonEn from "@translations/en/common.json";
import contactEn from "@translations/en/contact.json";
import fitEn from "@translations/en/fit.json";
import landingEn from "@translations/en/landing.json";
import legalEn from "@translations/en/legal.json";
import notFoundEn from "@translations/en/notFound.json";
import processPageEn from "@translations/en/processPage.json";
import seoEn from "@translations/en/seo.json";
import workEn from "@translations/en/work.json";

import aboutFr from "@translations/fr/about.json";
import commonFr from "@translations/fr/common.json";
import contactFr from "@translations/fr/contact.json";
import fitFr from "@translations/fr/fit.json";
import landingFr from "@translations/fr/landing.json";
import legalFr from "@translations/fr/legal.json";
import notFoundFr from "@translations/fr/notFound.json";
import processPageFr from "@translations/fr/processPage.json";
import seoFr from "@translations/fr/seo.json";
import workFr from "@translations/fr/work.json";

const resources = {
  en: {
    translation: {
      common: commonEn,
      landing: landingEn,
      seo: seoEn,
      fit: fitEn,
      work: workEn,
      about: aboutEn,
      processPage: processPageEn,
      legal: legalEn,
      contact: contactEn,
      notFound: notFoundEn,
    },
  },
  fr: {
    translation: {
      common: commonFr,
      landing: landingFr,
      seo: seoFr,
      fit: fitFr,
      work: workFr,
      about: aboutFr,
      processPage: processPageFr,
      legal: legalFr,
      contact: contactFr,
      notFound: notFoundFr,
    },
  },
} as const;

/**
 * Resolve the boot language synchronously, BEFORE the first React render.
 * Prerendered pages arrive with a locale-correct <html lang> and a fully
 * translated body — booting i18next in the default locale would make the
 * hydration pass render English text into a French DOM (mismatch → React
 * discards the server markup). URL path is the fallback for non-prerendered
 * shells (e.g. /fr/unknown served via the SPA fallback with lang="en").
 */
function detectInitialLocale(): SupportedLocale {
  if (typeof document !== "undefined") {
    const docLang = document.documentElement.lang;
    if (isLocale(docLang)) return docLang;
  }
  if (typeof window !== "undefined") {
    const seg = window.location.pathname.split("/")[1];
    if (isLocale(seg)) return seg;
  }
  return DEFAULT_LOCALE;
}

void i18n.use(initReactI18next).init({
  resources,
  lng: detectInitialLocale(),
  fallbackLng: DEFAULT_LOCALE,
  supportedLngs: [...SUPPORTED_LOCALES],
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
